import React from 'react';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { notifications } from '@mantine/notifications';
import { v4 as uuidv4 } from 'uuid';
import { ActionIcon, Text, useMantineTheme, Menu, ScrollArea, Box } from '@mantine/core';
import { IconBell } from '@tabler/icons-react';

import { useLoginContext } from "../context/loginContext";

import { utils, BE_API_ONE, tabProject, menuList, subMenuProject } from "../utils/globalVariables";
import { safetyDecodeJWT, getPropInSubLevelRole, stringDivider, sqlDateToHumanDate, safeValue } from "../utils/globalFunctions";

import DeadlinePengecekan from "../components/utilities/DeadlinePengecekan";
import DeadlineSelesai from "../components/utilities/DeadlineSelesai";

// import BrandComponent from "./BrandComponent";
// import MenuList from "./MenuList";
// import PencarianCepatModal from "./PencarianCepatModal";

const Notifications = () => {

  const mountedRef = React.useRef(true);
  const navigate = useNavigate();
  const theme = useMantineTheme();

  const { loginContext, handleSetLoginContext } = useLoginContext();

  const [data, setData] = React.useState({
    data: [],
    dataFlag: 'idle',
    dataLoading: false,
    dataRefresh: new Date(),
  });

  React.useEffect(() => {
    return () => {
      mountedRef.current = false;
    }
  }, [])

  const init = () => {
    setData(d => ({ ...d, dataLoading: true }));

    const formDT = new FormData();
    const formDTHeader = { 'Content-Type': 'application/json' }

    formDT.append('json_token', loginContext.syswebapp);
    formDT.append('project_is_cancel', '0');
    formDT.append('filter_arr_proses', JSON.stringify([
      utils.projectProcess.nota.value,
      utils.projectProcess.antrian.value,
      utils.projectProcess.pengerjaan.value,
      utils.projectProcess.qc.value,
      utils.projectProcess.selesai.value
    ]));

    axios({
      method: 'post',
      url: BE_API_ONE + '/notification_deadline_pengecekan',
      data: formDT,
      headers: formDTHeader,
    }).then((response) => {
      if (!mountedRef.current) return null;

      setData(d => ({ ...d, dataLoading: false }));

      if (response.data.flag_status === 'isset') {
        setData(d => ({
          ...d,
          data: response.data.data,
          dataFlag: response.data.data.length > 0 ? true : false,
        }));
      }

      if (response.data.flag_status === 'invalid-json-token') {
        handleSetLoginContext(null);
      }

      if (response.data.flag_status === 'user-inactive') {
        handleSetLoginContext(null);
      }
    }).catch(error => {
      if (!mountedRef.current) return null;

      setData(d => ({
        ...d,
        dataLoading: false,
      }));

      notifications.show({
        id: uuidv4(),
        title: utils.notification.warning.caption,
        message: error.message,
        color: utils.notification.warning.color,
        icon: utils.notification.warning.icon,
        withBorder: true,
        autoClose: true,
      })
    })
  }

  const handleSelectedProject = (stateProjectId, stateCustomerId, stateProjectStep) => {
    let tab = '';

    if (stateProjectStep === utils.projectProcess.nota.value) {
      tab = tabProject.nota;
    } else if (stateProjectStep === utils.projectProcess.antrian.value) {
      tab = tabProject.antrian;
    } else if (stateProjectStep === utils.projectProcess.pengerjaan.value) {
      tab = tabProject.pengerjaan;
    } else if (stateProjectStep === utils.projectProcess.qc.value) {
      tab = tabProject.qc;
    } else if (stateProjectStep === utils.projectProcess.selesai.value) {
      tab = tabProject.selesai;
    } else if (stateProjectStep === utils.projectProcess.sudah_diambil.value) {
      tab = tabProject.sudahDiambil;
    }

    navigate(`/${getPropInSubLevelRole(safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappsl'), 'slugLink', '')}/${menuList.project.slug}/${subMenuProject}/${tab}/${stateProjectStep === utils.projectProcess.nota.value ? stateCustomerId : stateProjectId}`, { replace: true });
  }

  return (
    <React.Fragment>
      <Menu
        shadow="md"
        width={300}

        onOpen={() => {
          init()
        }}

        styles={(tema) => ({
          //
        })}
      >
        <Menu.Target>
          <ActionIcon
            variant='subtle'
            radius='xl'
            size='lg'
            sx={{
              border: 0,
              color: theme.colorScheme === 'light' ? theme.colors.gray[9] : theme.colors.gray[2]
            }}
            title={'Notification'}
          >
            <IconBell
              size={22}
              strokeWidth={1.5}
            />
          </ActionIcon>
        </Menu.Target>

        <Menu.Dropdown pl='xs' pr='0'>
          <Menu.Label
            sx={(tema) => ({
              textTransform: 'uppercase',
              fontSize: tema.fontSizes.sm,
              marginTop: '.5rem',
              marginBottom: '.5rem',
              color: tema.colorScheme === 'light' ? tema.colors.gray[9] : tema.colors.dark[0]
            })}
          >
            Deadline Terlewat ({Array.isArray(data.data) ? data.data.length : 0})
          </Menu.Label>

          <ScrollArea.Autosize
            offsetScrollbars={true}
            mah='400px'
          >
            {data.dataLoading &&
              <Menu.Label>Loading..</Menu.Label>
            }

            {!data.dataLoading && Array.isArray(data.data) && (data.data.length > 0) && Object.keys(data.data).map((keyDT, indexDT) => {
              return (
                <Menu.Item
                  key={keyDT}
                  mb={Number(indexDT) + 1 === data.data.length ? '0' : '.5rem'}

                  sx={(tema) => ({
                    backgroundColor: tema.colorScheme === 'light' ? tema.fn.rgba(utils.priority[data.data[keyDT].project_priority].colorBgLight, 0.2) : tema.fn.rgba(utils.priority[data.data[keyDT].project_priority].colorBgDark, 0.1),
                    borderColor: tema.colorScheme === 'light' ? tema.fn.rgba(utils.priority[data.data[keyDT].project_priority].colorBgLight, 0.3) : tema.fn.rgba(utils.priority[data.data[keyDT].project_priority].colorBgDark, 0.5),
                    borderStyle: 'solid',
                    borderWidth: '1px',

                    '&:hover': {
                      backgroundColor: tema.colorScheme === 'light' ? tema.fn.rgba(utils.priority[data.data[keyDT].project_priority].colorBgLight, 0.3) : tema.fn.rgba(utils.priority[data.data[keyDT].project_priority].colorBgDark, 0.2),
                    }
                  })}

                  onClick={() => {
                    handleSelectedProject(data.data[keyDT].project_id, data.data[keyDT].customer_id, data.data[keyDT].project_process);
                  }}
                >
                  <Text size='sm' mb='.25rem' fw={500}>
                    {data.data[keyDT].customer_name} &#183; {stringDivider(data.data[keyDT].project_id, [4, 6, 8], '.', ' - ')}
                  </Text>

                  <Text size='xs'>{safeValue(data.data[keyDT].barang_nama, '[Nama barang]')}</Text>

                  <Box mt='.5rem' mb='.25rem'>
                    <Text size='xs'>
                      Deadline Cek &nbsp; {sqlDateToHumanDate({
                        stateDate: data.data[keyDT].date_line_pengecekan,
                        stateWithTime: false,
                        stateLang: 'id',
                        stateIsShort: true,
                        stateDay: false,
                        stateDefaultValue: ' - ',
                        stateDateType: 'day'
                      })}
                    </Text>
                  </Box>

                  <Box>
                    <DeadlinePengecekan
                      stateToday={data.data[keyDT].today}
                      stateDeadlinePengecekan={data.data[keyDT].date_line_pengecekan}
                      stateHasPengecekan={data.data[keyDT].has_pengecekan}
                      stateIsShort={true}
                    />
                  </Box>

                  <Box mt='.5rem' mb='.25rem'>
                    <Text size='xs'>
                      Deadline Selesai &nbsp; {sqlDateToHumanDate({
                        stateDate: data.data[keyDT].date_line_selesai,
                        stateWithTime: false,
                        stateLang: 'id',
                        stateIsShort: true,
                        stateDay: false,
                        stateDefaultValue: ' - ',
                        stateDateType: 'day'
                      })}
                    </Text>
                  </Box>

                  <Box>
                    <DeadlineSelesai
                      stateToday={data.data[keyDT].today}
                      stateDeadlineSelesai={data.data[keyDT].date_line_selesai}
                      stateTanggalSelesai={data.data[keyDT].tanggal_selesai}
                      stateIsShort={true}
                    />
                  </Box>

                  <Box mt='.5rem'>
                    <Text size='xs'>
                      Teknisi: {safeValue(data.data[keyDT].penerima_rekomendasi_nama, '[Teknisi]')} - {getPropInSubLevelRole(data.data[keyDT].penerima_rekomendasi_sub_level, 'caption', '[Jabatan]')}
                    </Text>
                  </Box>
                </Menu.Item>
              )
            })}

            {!data.dataLoading && Array.isArray(data.data) && (data.data.length <= 0) &&
              <Menu.Label>No Data</Menu.Label>
            }
          </ScrollArea.Autosize>
        </Menu.Dropdown>
      </Menu>
    </React.Fragment>
  )
}

export default Notifications;